<div class="container-fluid login-component">
    <div class="login-page d-flex flex-column justify-content-center align-items-center">
        <h4 class="auth-heading">New Password</h4>
        <div>
            <form class="custom-form" [formGroup]="newPasswordForm" (ngSubmit)="newPasswordHandle()">
                <div class="form-control-box field-with-icon form-group bottom-spacing">
                    <label for="password">Password : </label>
                    <input [type]="hidePassword ? 'password' : 'text'" class="form-control" id="password"
                        placeholder="Enter Password" formControlName="vPassword">
                    <button type="button" class="icon-btn" (click)="hidePassword = !hidePassword">
                        <img height="20" width="20"
                            [src]="hidePassword ? './assets/images/close-eye-icon.svg' : './assets/images/eye-icon.svg' "
                            alt="eye-icon">
                    </button>
                </div>
                <div class="form-control-box field-with-icon form-group bottom-spacing">
                    <label for="confirmPassword">Confirm Password : </label>
                    <input [type]="hidePassword1 ? 'password' : 'text'" class="form-control" id="confirmPassword"
                        placeholder="Enter Confirm Password" formControlName="confirmPassword">
                    <button type="button" class="icon-btn" (click)="hidePassword1 = !hidePassword1">
                        <img height="20" width="20"
                            [src]="hidePassword1 ? './assets/images/close-eye-icon.svg' : './assets/images/eye-icon.svg' "
                            alt="eye-icon">
                    </button>
                </div>
                <div class="text-center bottom-spacing">
                    <button type="submit" class="active-btn btn w-100 mt-3">Set Password</button>
                </div>
            </form>
            <div class="text-center sign-up">
                Remember your password ? <button class="grey-text" routerLink="/login">Sign In</button>
                here.
            </div>
        </div>
    </div>
</div>